import Storage from './storage';

function useTimeMachine(displayCode, onBack) {
  const performance = window.performance || {};
  const nav = performance.navigation || {};
  const isBackButton = nav.type === 2;
  const storage = Storage(`${displayCode}_${window.utf8Query}`);
  const hasHistory = !!storage.get();

  function clearSession() {
    Object.keys(sessionStorage).filter((key) => key.indexOf(displayCode) !== -1).forEach(key => {
      sessionStorage.removeItem(key);
    });
  }
  return {
    check() {
      (hasHistory && isBackButton) ? onBack(storage.get()) : clearSession();
    },
    storage
  };
}

export default useTimeMachine;


/** WEBPACK FOOTER **
 ** ./src/sports/core/useTimeMachine.js
 **/